import React from 'react';
import { ColumnProps } from 'antd/lib/table';

import {
  PartyInvolved,
  TicketQueryResult,
} from '@totem/components/ticketing/ticketing';
import IBTable from '@totem/components/ui_components/antDesignOverrides/IBTable';
import { formatDate } from '@totem/utilities/common';

import '../../../../ticketing/ticketing.css';

type Props = {
  ticket: TicketQueryResult;
};

const PartiesInvolvedTable = ({ ticket }: Props) => {
  const columns: ColumnProps<PartyInvolved>[] = [
    {
      title: 'Type',
      dataIndex: 'type',
      key: 'type',
      showSorterTooltip: true,
      sortDirections: ['ascend', 'descend'],
      sorter: (compA, compB) =>
        compA.type === compB.type ? 0 : compA.type > compB.type ? 1 : -1,
    },
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
      showSorterTooltip: true,
      sortDirections: ['ascend', 'descend'],
      sorter: (compA, compB) =>
        compA.name === compB.name ? 0 : compA.name > compB.name ? 1 : -1,
    },
    {
      title: 'Email',
      dataIndex: 'email',
      key: 'email',
      render: (_, partyInvolved: PartyInvolved) => (
        <a href={`mailto:${partyInvolved.email}`}>{partyInvolved.email}</a>
      ),
      showSorterTooltip: true,
      sortDirections: ['ascend', 'descend'],
      sorter: (compA, compB) =>
        compA.email === compB.email ? 0 : compA.email > compB.email ? 1 : -1,
    },
    {
      title: 'Phone',
      dataIndex: 'phone',
      key: 'phone',
      showSorterTooltip: true,
      sortDirections: ['ascend', 'descend'],
      sorter: (compA, compB) =>
        compA.phone === compB.phone ? 0 : compA.phone > compB.phone ? 1 : -1,
    },
    {
      title: 'Involvement Start',
      dataIndex: 'involvementStart',
      key: 'involvementStart',
      render: (_, partyInvolved: PartyInvolved) =>
        formatDate(partyInvolved.involvementStart),
      sorter: (compA, compB) =>
        compA.involvementStart === compB.involvementStart
          ? 0
          : compA.involvementStart > compB.involvementStart
            ? 1
            : -1,
      showSorterTooltip: true,
      sortDirections: ['ascend', 'descend'],
    },
  ];

  const getPartiesInvolved = () => {
    if (ticket !== null) {
      if (ticket.ticket !== null) {
        return ticket.ticket.partiesInvolved.filter(
          (chk) => chk.status === 'ACTIVE',
        );
      }
    }
    return [];
  };

  return (
    <IBTable
      showSorterTooltip
      columns={columns}
      dataSource={getPartiesInvolved()}
      loading={false}
      rowKey="id"
    />
  );
};

export default PartiesInvolvedTable;
